import { LucideCalendarDays } from 'lucide-react';

import { CalendarLayout } from './_components/_layouts/CalendarLayout';

import { createAppModule } from '~/shared/routing/createAppModule';
import { createModuleNav } from '~/shared/routing/createModuleNav';
import { createModuleRoutes } from '~/shared/routing/createModuleRoutes';

const basePath = '/calendar';

export const calendarRoutes = createModuleRoutes({
  root: {
    path: basePath,
    label: (t) => t.menu.calendar.root,
    icon: LucideCalendarDays,
    component: CalendarLayout,
  },
});

const calendarNav = createModuleNav(($) => $(calendarRoutes.root));

export const calendarModule = createAppModule({
  routes: calendarRoutes,
  nav: calendarNav,
});
